<template>
  <article class="inputs">
    <section class="field display">
      <label>{{ $tc('INPUT', 2) }}</label>

      <div class="ui blue label" v-for="input in inputs" :key="input.name">
        <a><i class="remove icon" @click.stop="remove(input)"></i></a>
        {{ input.name }}
        <div class="detail">{{ getSubjectName(input.type) }}</div>
      </div>

      <span v-if="inputs && !inputs.length && !addVisible">
        {{ $t('NO_THING_YET', { thing: $tc('INPUT') }) }}
      </span>

      <button
        class="circular ui icon button"
        v-if="!addVisible"
        @click.prevent="toggleAddVisible()"
        :disabled="isDisabled"
      >
        <i class="icon plus"></i>
      </button>
    </section>

    <section class="fields" v-if="addVisible">
      <div class="field">
        <input
          id="inputName"
          type="text"
          :placeholder="$t('NAME')"
          v-model="input.name"
          required
          :disabled="isDisabled"
          autocomplete="off"
        />
      </div>

      <dropdown-select
        :items="possibleTypes"
        :placeholder-text="$tc('TYPE', 1)"
        :select-handler="typeSelected"
        :required="true"
        class="six wide inputSelect"
        :disabled="isDisabled"
      ></dropdown-select>

      <footer>
        <button
          class="circular ui icon button"
          type="button"
          @click.prevent="done"
          :disabled="isDisabled"
        >
          <i class="icon checkmark"></i>
        </button>
      </footer>
    </section>
  </article>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../scss/variables';

.ui.label {
  margin: 3px;
}

.inputSelect {
  position: relative;
  z-index: 10;
}
</style>

<script>
// @flow
import Vue from 'vue'
import { DropdownSelect } from 'ui'
import { Subject, Toast } from 'services'
import { map, catchError } from 'rxjs/operators'

const possibleTypes = [{ name: 'String', id: 'string' }]

const defaultInput = {
  name: '',
  type: possibleTypes[0].id
}

export default {
  name: 'flow-inputs',
  components: { DropdownSelect },

  props: {
    inputs: {
      type: Array,
      default: () => []
    },
    addHandler: {
      type: Function,
      default: () => () => {}
    },
    removeHandler: {
      type: Function,
      default: () => () => {}
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      possibleTypes: [...possibleTypes],
      addVisible: false,
      input: { ...defaultInput }
    }
  },

  methods: {
    readAllSubjects() {
      return Subject.readAllSubjects()
        .then(subjects => {
          this.possibleTypes = [...possibleTypes, ...subjects]
          this.input.type = this.possibleTypes.length ? this.possibleTypes[0].id : '' // Selects first subject in the dropdown
        })
        .catch(err => {
          if (err.response && err.response.status !== 404) {
            Toast.error(
              this.$i18n.t('ERR', {
                action: this.$i18n.t('READ', { thing: this.$i18n.tc('TYPE', 2) })
              })
            )
          }
          console.error(err)
          throw err
        })
    },

    getSubjectName(subjectId: string) {
      const subject = this.possibleTypes.find(s => s.id === subjectId)
      return subject ? subject.name : ''
    },

    typeSelected(type: Object) {
      this.input.type = type.id
    },

    done() {
      // If there's an input selected, call the selection handler.
      if (this.input.name) {
        this.addHandler(this.input)
        this.input = { ...defaultInput } // Reset input name / reset input type to first possible value
      }

      this.toggleAddVisible()
    },

    remove(input: Object) {
      if (!this.isDisabled) {
        this.removeHandler(input)
      }
    },

    toggleAddVisible() {
      this.addVisible = !this.addVisible
    }
  },

  mounted() {
    this.readAllSubjects()
  }
}
</script>
